import React, { useEffect, useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  fetchScheduledTaskInfo,
  unassignMember,
  fetchUnassignedUser,
  assignUser,
  fetchUnassignedStaff,
} from "../../actions/staff/scheduledActions";
import DataTable from "../../components/table/DataTable";
import Button from "../../components/cofButton/Button"; // Pretpostavljamo da imate Button komponentu
import ThemeContext from "../../theme/ThemeContext";
import { Row, Col, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  ASSIGN_USER_RESET,
  UNASSIGN_MEMBER_RESET,
} from "../../constants/staff/scheduledListConstants";
import Select from "react-select";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { formatDate, formatBirth } from '../../components/dateUtils';
import { createScheduledTaskComment, getScheduledTaskComment } from "../../actions/staff/scheduledTaskCommentsActions";
import FileUploadComponent from "../../components/FileUploadComponent"
import UploadedFilesComponent  from "../../components/UploadedFilesComponent"
import { uploadDocument, getDocument } from '../../actions/uploadAction';
import { CREATE_SCHEDULED_TASK_COMMENT_RESET} from "../../constants/staff/scheduledTaskCommentsConstants";
import asset from "../../img/asset.png";
import './ScheduledTaskInfoScreen.css';
const ScheduledTaskInfoScreen = () => {
  const { t } = useTranslation();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  console.log(userInfo)
  const { scheduletaskid } = useParams();
  const { clubid } = useParams();
  console.log(scheduletaskid);
  const dispatch = useDispatch();
  const [selectedPlayer, setSelectedPlayer] = useState(null);

  const [selectedStaff, setSelectedStaff] = useState(null);
  const [taskComment, setTaskComment] = useState('');
  const handleStaffSelect = (event) => {
    setSelectedStaff(event.target.value);
  };
  const createCommentFunction = useSelector((state) => state.createScheduledTaskComment)
  const { loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate,
  } = createCommentFunction
  const ScheduledTaskComments = useSelector((state) => state.scheduledTaskComment)
  const { loading: loadingComments,
    error: errorUpdateComments,
    success: successComments,
  } = ScheduledTaskComments


  const handleAddComment = () => {
    // Dispatch the action to create a scheduled task comment
    dispatch(createScheduledTaskComment(scheduletaskid, { body: taskComment, createdBy: userInfo._id }));
    setTaskComment(''); // Clear the comment input after dispatching
  };

 

  useEffect(() => {
    if (successUpdate) {
      dispatch(fetchScheduledTaskInfo(userInfo.club, scheduletaskid));
      dispatch({type:CREATE_SCHEDULED_TASK_COMMENT_RESET})
    }
  }, [dispatch, successUpdate, successComments,scheduletaskid])

  const uploaddoc = useSelector((state) => state.documentUpload);
  const { success: successUpload } = uploaddoc;

  // Koristimo useEffect kuku kako bismo pratili promene u successUpload stanju
  useEffect(() => {
    // Ako je upload uspešan, osvežimo listu dokumenata
    if (successUpload) {
      dispatch(getDocument(scheduletaskid));
    }
  }, [successUpload, dispatch, scheduletaskid]); // useEffect će se ponovo izvršiti kada se promeni successUpload promenljiva

  const handlePlayerSelect = (event) => {
    setSelectedPlayer(event.target.value);
  };

  const assignUserState = useSelector((state) => state.assignUser);
  const {
    loading: loadingAssign,
    error: errorAssign,
    success: successAssign,
  } = assignUserState;
 
  console.log(assignUserState);
  console.log(selectedPlayer);
  const handleAssignPlayerToTask = () => {
    if (selectedPlayer !== null) {
      console.log("Selektovani igrači:", selectedPlayer);
      const selectedPlayerIds = selectedPlayer.map((option) => option.value);
      dispatch(
        assignUser(
          userInfo.club,
          scheduletaskid,
          selectedPlayerIds,
          userInfo._id
        )
      );
      dispatch({ type: ASSIGN_USER_RESET });
    }
  };

  const taskInfo = useSelector((state) => state.scheduledTaskInfo);
  const { loading, error, scheduledTask } = taskInfo;
  console.log(scheduledTask);

  const unassignMemberState = useSelector((state) => state.unassignMember);
  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = unassignMemberState;

  useEffect(() => {
    dispatch(fetchScheduledTaskInfo(userInfo.club, scheduletaskid));
  }, [dispatch, userInfo.club, scheduletaskid, successDelete, successAssign]);

  const unassignedUsers = useSelector((state) => state.fetchUnassignedUser);
  const { unassignedUser } = unassignedUsers;
  console.log(unassignedUsers)
  console.log(unassignedUser);
  const unassignedStaffs = useSelector((state) => state.fetchUnassignedStaff);
  const { unassignedStaff } = unassignedStaffs;

  console.log(unassignedStaff);

  useEffect(() => {
    console.log(
      "Poziva se useEffect za osvezavanje posle uspesnog asajnovanja"
    );
    console.log(scheduletaskid);
    dispatch(fetchUnassignedUser(userInfo.club, scheduletaskid));
    dispatch(fetchUnassignedStaff(userInfo.club, scheduletaskid));
  }, [successAssign, successDelete]);

  const theme = useContext(ThemeContext);
  const { colors, fonts } = theme;
  console.log(taskInfo);
  const columns = [
    { label: t("AssignedBy").toUpperCase(), dataKey: "assignedBy" },
    { label: t("Assigned To").toUpperCase(), dataKey: "assignedTo" },
    {
      label: t("Confirmation Status").toUpperCase(),
      dataKey: "confirmationStatus",
    },
    {
      label: t("Resolved Status").toUpperCase(),
      dataKey: "resolvedStatus",
    },
  ];
  console.log(scheduledTask);
  const data =
    scheduledTask?.assignments.map((assignment) => ({
      _id: assignment.assignedTo._id,
      userId: assignment.assignedTo._id,
      confirmationStatus: assignment.confirmationStatus
        ? assignment.confirmationStatus.status // Provera da li postoji confirmationStatus pre pristupa statusu
        : "N/A", // Ako ne postoji, prikažite "N/A"
      assignedBy: assignment.assignedBy
        ? assignment.assignedBy.name + " " + assignment.assignedBy.surname
        : "",
      assignedTo:
        assignment.assignedTo.name + " " + assignment.assignedTo.surname,
        resolvedStatus: assignment?.resolvedStatus?.status || "UNRESOLVED",
    })) || [];

  const handleAssignStaffToTask = () => {
    if (selectedStaff !== null) {
      console.log("Selektovano osoblje:", selectedStaff);
      const selectedStaffIds = selectedStaff.map((option) => option.value);
      dispatch(
        assignUser(
          userInfo.club,
          scheduletaskid,
          selectedStaffIds,
          userInfo._id
        )
      );
      dispatch({ type: ASSIGN_USER_RESET });

    }
  };

  const unassignHandler = async (userId) => {
    try {
      dispatch({ type: UNASSIGN_MEMBER_RESET });
      dispatch(unassignMember(userInfo.club, scheduletaskid, userId), {
        type: UNASSIGN_MEMBER_RESET,
      });
      // Nakon unassign operacije, ponovo dohvatite informacije o zakazanom zadatku
      dispatch(fetchScheduledTaskInfo(userInfo.club, scheduletaskid));
      // Osvežiti i unassigned liste
      dispatch(fetchUnassignedUser(userInfo.club, scheduletaskid));
      dispatch(fetchUnassignedStaff(userInfo.club, scheduletaskid));
    } catch (error) {
      console.error("Error unassigning member:", error);
    }
  };

  const actionHandlers = {
    [t("Unassign")]: unassignHandler,
  };
  console.log(scheduledTask);

  const staffColumns = [
    { label: t("AssignedBy").toUpperCase(), dataKey: "assignedBy" },
    { label: t("Assigned To").toUpperCase(), dataKey: "assignedTo" },
    {
      label: t("Confirmation Status").toUpperCase(),
      dataKey: "confirmationStatus",
    },
    {
      label: t("Resolved Status").toUpperCase(),
      dataKey: "resolvedStatus",
    },
    { label: "Type".toUpperCase(), dataKey: "type" }, // Dodato polje za prikazivanje tipa (osoblje)
  ];

  const staffActions = [
    { variant: "danger", icon: faTrash, label: "Unassign" },
    // Dodajte druge akcije za osoblje prema potrebi
  ];

  const staffActionLabels = ["Unassign"];
  const UnassignStaffHendler = async (userId) => {
    console.log("Poziva se unassign staff, userId: " + userId);
    try {
      dispatch({ type: UNASSIGN_MEMBER_RESET });
      dispatch(unassignMember(userInfo.club, scheduletaskid, userId), {
        type: UNASSIGN_MEMBER_RESET,
      });
      // Nakon unassign operacije, ponovo dohvatite informacije o zakazanom zadatku
      dispatch(fetchScheduledTaskInfo(userInfo.club, scheduletaskid));
      // Osvežiti i unassigned liste
      dispatch(fetchUnassignedUser(userInfo.club, scheduletaskid));
      dispatch(fetchUnassignedStaff(userInfo.club, scheduletaskid));
    } catch (error) {
      console.error("Error unassigning member:", error);
    }
  };
  const staffActionHandlers = {
    Unassign: UnassignStaffHendler,
  };

  console.log(scheduledTask);

  const staffData =
  scheduledTask?.staffAssignments.map((staffAssignment) => ({
    _id: staffAssignment.assignedTo?._id || "", // Provera da li `assignedTo` postoji
    userId: staffAssignment.assignedTo?._id || "", // Provera da li `assignedTo` postoji
    confirmationStatus: staffAssignment.confirmationStatus
      ? staffAssignment.confirmationStatus.status
      : "N/A",
    assignedBy: staffAssignment.assignedBy
      ? (staffAssignment.assignedBy.name || "") +
        " " +
        (staffAssignment.assignedBy.surname || "")
      : "",
    assignedTo: staffAssignment.assignedTo
      ? (staffAssignment.assignedTo.name || "") +
        " " +
        (staffAssignment.assignedTo.surname || "")
      : "select staff in your settings please", // Koristimo `t` za prevođenje poruke
    type: "Staff",
    resolvedStatus: staffAssignment?.resolvedStatus?.status || "UNRESOLVED",
  })) || [];


  return (
    <div className="task-info-container">
      {/* Header Section */}
      <div className="task-info-header">
        <h2 className="task-info-title">{t("ScheduledTaskInfo")}</h2>
      </div>

      {loading ? (
        <div className="loading-state">Loading...</div>
      ) : error ? (
        <div className="error-state">Error: {error}</div>
      ) : (
        scheduledTask && (
          <div>
            {/* Task Details Card */}
            <div className="task-details-card">
              <table className="task-details-table">
                <tbody>
                  <tr>
                    <td>{t("CreatedBy")}:</td>
                    <td>
                      {scheduledTask.createdBy
                        ? (scheduledTask.createdBy.name || "") + 
                          (scheduledTask.createdBy.surname ? ` ${scheduledTask.createdBy.surname}` : "")
                        : "system"}
                    </td>
                  </tr>
                  <tr>
                    <td>{t("StartTime")}:</td>
                    <td>{formatDate(scheduledTask.startTime)}</td>
                  </tr>
                  <tr>
                    <td>{t("Name")}:</td>
                    <td>{scheduledTask.name}</td>
                  </tr>
                  <tr>
                    <td>{t("Status")}:</td>
                    <td>{t(scheduledTask.status)}</td>
                  </tr>
                  <tr>
                    <td>{t("Type")}:</td>
                    <td>{t(scheduledTask.type)}</td>
                  </tr>
                  <tr>
                    <td>{t("Location")}:</td>
                    <td>{scheduledTask.location}</td>
                  </tr>
                  <tr>
                    <td>{t("Duration")}:</td>
                    <td>{scheduledTask.duration}</td>
                  </tr>
                  <tr>
                    <td>{t("Description")}:</td>
                    <td>{scheduledTask.description}</td>
                  </tr>
                  {scheduledTask.attendanceConfirmationUntil && (
                    <tr>
                      <td>{t("Attendance Confirmation Until")}</td>
                      <td>{formatDate(scheduledTask.attendanceConfirmationUntil)}</td>
                    </tr>
                  )}
                  {scheduledTask.deadline && (
                    <tr>
                      <td>{t("Deadline")}</td>
                      <td>{formatDate(scheduledTask.deadline)}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            
            {/* File Upload Section */}
            <div className="content-section file-upload-section">
              <h3 className="section-title">{t("Documents")}</h3>
              <FileUploadComponent scheduledTaskId={scheduletaskid} />
              <UploadedFilesComponent scheduledTaskId={scheduletaskid} />
            </div>

            {/* Comments Section */}
            <div className="content-section comments-section">
              <h3 className="section-title">{t("Comment")}</h3>
              <div>
                {scheduledTask && scheduledTask.comments && scheduledTask.comments.map((comment) => (
                  <div key={comment._id} className="comment-item">
                    <div className="comment-header">
                      <span>{t("CreatedBy")}: {comment.createdBy.name} {comment.createdBy.surname}</span>
                      <span>{formatDate(comment.createdAt)}</span>
                    </div>
                    <div className="comment-body">"{comment.body}"</div>
                  </div>
                ))}
              </div>
              
              <div className="add-comment-form">
                <h5 className="add-comment-title">{t("AddCommentForTask")}</h5>
                <Row>
                  <Col xs={12} lg={10} className="py-1">
                    <Form.Group controlId="taskComment">
                      <Form.Control
                        type="text"
                        value={taskComment}
                        onChange={(e) => setTaskComment(e.target.value)}
                        style={{ backgroundColor: "#415f74", borderColor: "white", borderRadius: "0", color: "white", opacity: "0.6" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} lg={2} className="py-1">
                    <Button className='assignment-button' onClick={handleAddComment}>{t("AddComment")}</Button>
                  </Col>
                </Row>
              </div>
            </div>

            {/* Player Assignment Section */}
            <div className="content-section assignment-section">
              <h3 className="section-title">{t("Assign task to players")}</h3>
              <div className="assignment-row">
                <div className="assignment-select">
                  <Select
                    placeholder={t("Select player")}
                    options={unassignedUser.map((user) => ({
                      value: user.user._id,
                      label: `${user.user.name} ${user.user.surname}`,
                    }))}
                    isMulti
                    onChange={(selectedOptions) =>
                      setSelectedPlayer(selectedOptions)
                    }
                    styles={{
                      option: (provided, state) => ({
                        ...provided,
                        color: "black",
                      }),
                      singleValue: (provided, state) => ({
                        ...provided,
                        color: "black",
                      }),
                      control: (provided, state) => ({
                        ...provided,
                        backgroundImage: "linear-gradient(#1d4e5b, #08214c)",
                        borderRadius: "0",
                        border: "none",
                        color: "white",
                        cursor: "pointer",
                      }),
                    }}
                  />
                </div>
                <Button
                  className="assignment-button"
                  onClick={handleAssignPlayerToTask}
                >
                  {t("Assign task to players")}
                </Button>
              </div>
            </div>

            {/* Player DataTable */}
            <div className="datatable-wrapper">
              <h4 className="datatable-title">{t("Assigned Players")}</h4>
              <DataTable
                columns={columns}
                data={data}
                actions={[
                  { variant: "danger", icon: faTrash, label: t("Unassign") },
                ]}
                actionLabels={[t("Unassign")]}
                buttonStyle={{ marginRight: "5px" }}
                actionHandlers={actionHandlers}
              />
            </div>

            {/* Staff Assignment Section */}
            <div className="content-section assignment-section">
              <h3 className="section-title">{t("Assign task to staff")}</h3>
              <div className="assignment-row">
                <div className="assignment-select">
                  <Select
                    placeholder={t("Select staff")}
                    options={unassignedStaff.map((staff) => ({
                      value: staff.user._id,
                      label: `${staff.user.name} ${staff.user.surname}`,
                    }))}
                    isMulti
                    onChange={(selectedOptions) =>
                      setSelectedStaff(selectedOptions)
                    }
                    styles={{
                      option: (provided, state) => ({
                        ...provided,
                        color: "black",
                      }),
                      singleValue: (provided, state) => ({
                        ...provided,
                        color: "black",
                      }),
                      control: (provided, state) => ({
                        ...provided,
                        backgroundImage: "linear-gradient(#1d4e5b, #08214c)",
                        borderRadius: "0",
                        border: "none",
                        color: "white",
                        cursor: "pointer",
                      }),
                    }}
                  />
                </div>
                <Button
                  className="assignment-button"
                  onClick={handleAssignStaffToTask}
                >
                  {t("Assign task to staff")}
                </Button>
              </div>
            </div>

            {/* Staff DataTable */}
            <div className="datatable-wrapper">
              <h4 className="datatable-title">{t("Assigned Staff")}</h4>
              <DataTable
                columns={staffColumns}
                data={staffData}
                actions={staffActions}
                actionLabels={staffActionLabels}
                actionHandlers={staffActionHandlers}
              />
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default ScheduledTaskInfoScreen;
